enum AuthError {
  AuthenticationError = 'AuthenticationError',
  TokenExpiredError = 'TokenExpiredError',
  GenerateCookieError = 'GenerateCookieError',
}
export default AuthError;
